//@flow
import React from 'react';
import injectSheet from 'react-jss';
import spinnerGifIdentity from '../images/spinner-identity.gif';

const LoadingSpinner = (props: Props) => {
    const { classes } = props;
    return (
        <div className={classes.root}>
            <img src={spinnerGifIdentity} />
        </div>
    );
}

type Props = {
    classes: Object
}

const style = {
    root: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '80vh'
    }
}

export default injectSheet(style)(LoadingSpinner);
